export default () => ({ container: { width: '98%' } });
